// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@5.2.5_webpack@4.47.0_webpack-cli@4.10.0_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.plv-ia-load-error[data-v-2992a7fc] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 12px;\n  color: rgb(124 123 123);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
